<template>
  <div>
    <div v-for="alert in alerts">
      <v-alert :type="alert.type" dismissible v-if="alert.text">
        {{ alert.text }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters("globals", { alerts: "getAlerts" })
  }
}
</script>
